export default __webpack_public_path__ + "static/media/mTop_3.96a34c8c.bin";